import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {ApiResponseModel, ApiVisa} from '../shared';


@Injectable({
  providedIn: 'root'
})
export class CountryService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'country';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'country';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'country';
    this.httpClient = http;
  }
}
